import PropTypes from "prop-types";
import React, { useMemo, memo } from "react";
import { useTheme } from "@mui/material/styles";
import {
  Box,
  Grid,
  IconButton,
  Stack,
  Typography,
  Button,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import MenuTwoToneIcon from "@mui/icons-material/MenuTwoTone";
import InfoIcon from "@mui/icons-material/Info";

import ProfileSection from "./ProfileSection";
import DatePickerComp from "views/Insights/DatePicker";
import FilterComponent from "views/Insights/FilterOption";
import { drawerWidth } from "config.js";
import * as actionTypes from "store/actions";
import {
  driverJsInit,
  driverJsInitStores,
  driverJsInitTeams,
} from "driverConfig";

const getLinkClassName = (isActive, ftypeget) => `
  text-lg hover:border-b-2 hover:border-custom${ftypeget} hover:text-custom${ftypeget}-dark
  ${isActive ? `border-b-2 border-custom${ftypeget} text-custom${ftypeget}-dark` : ''}
`.trim();

const NavLink = memo(({ to, onClick, isActive, children, ftypeget }) => (
  <Link
    to={to}
    onClick={onClick}
    className={getLinkClassName(isActive, ftypeget)}
  >
    {children}
  </Link>
));

NavLink.propTypes = {
  to: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  ftypeget: PropTypes.string.isRequired,
};

const Header = memo(({ drawerToggle }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const location = useLocation();
  
  const { flType: ftypeget } = useSelector((state) => ({
    flType: state.customization.flType,
  }));

  const userData = useMemo(() => JSON.parse(localStorage.getItem("userData")), []);
  const isFilrtreActive = userData?.user_role === "NHQ";
  const hideFilter = /^\/main\/stores\/storeinsight\/overview\/[^/]+$/.test(location.pathname);

  const handleTourStart = () => {
    const path = window.location.pathname;
    if (path === "/main/insights") {
      localStorage.setItem("product_tour_seen", "false");
      driverJsInit();
    } else if (path === "/main/stores") {
      localStorage.setItem("product_tour_seen_stores", "false");
      driverJsInitStores();
    } else if (path === "/main/team") {
      localStorage.setItem("product_tour_seen_teams", "false");
      driverJsInitTeams();
    }
  };

  const navigationLinks = useMemo(() => [
    // {
    //   to: "/main/insights",
    //   label: "Insights",
    //   action: "insights",
    // },
    // {
    //   to: "/main/stores",
    //   label: "Stores",
    //   action: "customers",
    // },
    // {
    //   to: "/main/team",
    //   label: "Teams",
    //   action: "team",
    // },
  ], []);

  return (
    <>
      <Box width={drawerWidth}>
        <div className="flex">
          {/* Color classes for theme */}
          <div className="hover:border-customAll hover:text-customAll-dark border-customAll text-customAll-dark" />
          <div className="hover:border-customBlush hover:text-customBlush-dark border-customBlush text-customBlush-dark" />
          <div className="hover:border-customLace hover:text-customLace-dark border-customLace text-customLace-dark" />
          
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <Grid item>
              <Box mt={0.5}>
                <Typography
                  // onClick={() => window.open("/main/insights", "_self")}
                  // onClick={() => window.open("/main/stores", "_self")}
                  onClick = {() => window.open("/main/stores/storeinsight/overview/P001", "_self")}
                  variant="h2"
                  align="left"
                  className="black cursor-pointer"
                  sx={{ width: "100%", paddingLeft: 1.6 }}
                >
                  Neo QCR
                </Typography>
              </Box>
            </Grid>
          </Box>
          
          <Grid sx={{ display: { xs: "none", md: "none" } }} item>
            <IconButton
              className="text-black ml-0.5"
              edge="start"
              sx={{ mr: theme.spacing(1.25), color: "white" }}
              aria-label="open drawer"
              onClick={drawerToggle}
              size="large"
            >
              <MenuTwoToneIcon sx={{ fontSize: "1.5rem" }} />
            </IconButton>
          </Grid>
        </div>
      </Box>

      <Box sx={{ flexGrow: 1 }}>
        <Box
          className="space-x-8"
          sx={{ flexGrow: 1, display: { xs: "none", md: "block" } }}
        >
          {navigationLinks.map(({ to, label, action }) => (
            <NavLink
              key={to}
              to={to}
              onClick={() => dispatch({ type: actionTypes.MENU_OPEN, isOpen: action })}
              isActive={location.pathname === to}
              ftypeget={ftypeget}
            >
              {label}
            </NavLink>
          ))}

          <a
            href="https://neophyte.ai/contact"
            className={`text-lg hover:border-b-2 hover:border-custom${ftypeget} hover:text-custom${ftypeget}-dark`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Us
          </a>

          <Button variant="outlined" onClick={handleTourStart}>
            <Typography>Start Tour</Typography>
            <span className="px-2">
              <InfoIcon />
            </span>
          </Button>
        </Box>
      </Box>

      <Stack
        direction="row"
        spacing={2}
        sx={{
          alignItems: "center",
          gap: 2,
        }}
      >
        {isFilrtreActive && !hideFilter && (
          <Box sx={{ marginBottom: 2 }} className="filter invisible">
            <FilterComponent />
          </Box>
        )}

        <Box
          sx={{ marginBottom: 2, position: "relative" }}
          className="calendar"
        >
          <DatePickerComp />
        </Box>

        <Box className="profile">
          <ProfileSection />
        </Box>
      </Stack>
    </>
  );
});

Header.propTypes = {
  drawerToggle: PropTypes.func,
};

Header.displayName = 'Header';
NavLink.displayName = 'NavLink';

export default Header;
